import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function FalcoDead() {
  const dateTexts = ['1875年'];
  const title = 'カメリアファルコ死去';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2019/03/Camellia_Falco.jpg'
  const description = (
    <>
      <a href='/camellia-falco'>
        {'カメリアファルコ'}
      </a>
      {'が74歳で死亡する。'}
      {'父の博物館の二代目館長を務めると同時に、飛行の研究に人生を捧げ、仲間とともにドリームフライヤーを作り上げた。'}
    </>
  );


  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
      objectPosition='20%'
    />
  );
}

export default FalcoDead;
